import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-4 bg-brand-light text-center">
      <div>
        <p className="font-heading font-extrabold text-7xl text-gradient-brand">404</p>
        <h1 className="mt-4 text-2xl font-bold font-heading text-brand-navy">{t("products.empty")}</h1>
        <Button data-testid="notfound-home" onClick={() => navigate("/")} className="mt-6 rounded-full bg-brand-electric hover:bg-brand-electric/90 text-white">{t("nav.home")}</Button>
      </div>
    </div>
  );
};

export default NotFound;
